<template>
    <div>
        <b-alert show>
            <span>
                Descrição do Item:
                <strong>
                    {{ item.descricao }}
                </strong>
            </span>
            <br />
        </b-alert>
        <b-tabs>
            <b-tab title="Cabeçalho">
                    <cabecalho
                        :item="item"
                    ></cabecalho>  
                </b-tab>
                <b-tab title="Condições Gerais">
                    <condicoes-gerais
                        :item="item"
                    ></condicoes-gerais>
                </b-tab>
                <b-tab title="Tabelas">
                    <tabelas
                        :item="item"
                    ></tabelas>
                </b-tab>                
                <!-- <b-tab title="Observação">
                    <observacao
                        :item="item"
                    ></observacao>
                </b-tab> -->
        </b-tabs>
        <div class="d-flex flex-row-reverse mt-3">
                <b-form-group>
                    <b-button variant="danger" @click.stop="voltar()">
                        <span>
                            <i class="fa fa-history mr-2"></i> Retornar para Itens
                        </span>
                    </b-button>
                </b-form-group> 
            </div>
    </div>
</template>

<script>
import Cabecalho from './detalharItemTabs/cabecalhoDetalhar.vue'
import CondicoesGerais from './detalharItemTabs/condicoesgeraisDetalhar.vue'
import Tabelas from './detalharItemTabs/tabelasDetalhar.vue'
import Observacao from './detalharItemTabs/observacaoDetalhar.vue'

export default {
    props: {
        item: {
            type: Object,
            default: () => {}
        }
    },

    components: {
        Cabecalho,
        CondicoesGerais,
        Tabelas,
        Observacao
    },

    methods: {
        voltar() {
            this.$emit('fecharDetalharItem')
        },
    }
}
</script>

<style>

</style>